<style lang="scss" scoped>
/deep/ .comp-work-service-areas-dialog {
    max-width: 520px;
}
</style>

<template>
    <div class="comp-work-service-areas">
        <el-dialog :title="title" custom-class="c-el-dialog comp-work-service-areas-dialog" :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="true" :append-to-body="true">
            <el-alert class="mrgb10" type="warning" :closable="false">
                <span slot="title">
                    仅统计分析平台存在的数据，如数据不全请联系管理员同步数据。<br />
                    统计时间范围：<span class="col_danger fwb">{{ dialogData.beginDate }} 至 {{ dialogData.endDate }}</span>
                </span>
            </el-alert>
            <el-collapse v-model="activeNames" v-if="moveAreas.length > 0 || batteryChangeAreas.length > 0 || reparionAreas.length > 0">
                <el-collapse-item title="挪车服务区" name="1" v-if="moveAreas.length > 0">
                    <template slot="title">
                        <i class="el-icon-truck f16 mrgr5"></i> 挪车服务区
                    </template>
                    <div class="mrgl20">
                        <el-tag v-for="item in moveAreas" :key="item" type="primary" size="medium" class="mrgb5 mrgr5">
                            【<span class="fwb">{{ item.platform || "" }}</span>】{{ item.name || "" }}
                        </el-tag>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="换电服务区" name="2" v-if="batteryChangeAreas.length > 0">
                    <template slot="title">
                        <i class="el-icon-c-scale-to-original f16 mrgr5"></i> 换电服务区
                    </template>
                    <div class="mrgl20">
                        <el-tag v-for="item in batteryChangeAreas" :key="item" type="danger" size="medium" class="mrgb5 mrgr5">
                            【<span class="fwb">{{ item.platform || "" }}</span>】{{ item.name || "" }}
                        </el-tag>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="维修服务区" name="3" v-if="reparionAreas.length > 0">
                    <template slot="title">
                        <i class="el-icon-suitcase f16 mrgr5"></i> 维修服务区
                    </template>
                    <div class="mrgl20">
                        <el-tag v-for="item in reparionAreas" :key="item" type="warning" size="medium" class="mrgb5 mrgr5">
                            【<span class="fwb">{{ item.platform || "" }}</span>】{{ item.name || "" }}
                        </el-tag>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div v-else class="mrgt20 tc">
                <span class="col9">~暂无数据~</span>
            </div>
            <span slot="footer">
                <el-button size="small" @click="_close()">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import permission from "@/mixins/permission"
import * as funEmployees from '@/api/employees'
export default {
    name: "compWorkServiceAreas",
    mixins: [permission],
    data() {
        return {
            title: "",
            showDialog: false,
            dialogData: {},
            activeNames: ["1", "2", "3"],
            moveAreas: [],
            batteryChangeAreas: [],
            reparionAreas: []
        }
    },
    methods: {
        open(params) {
            this.title = `查看【${params.name} | ${params.telOrName}】工作过的服务区`
            this.dialogData = JSON.parse(JSON.stringify(params))
            this.moveAreas = []
            this.batteryChangeAreas = []
            this.reparionAreas = []
            this.getAreasData(params)
        },
        async getAreasData(params) {
            if (this.isOperationMoveTask) {
                await funEmployees.GetEmployeeMoveTaskArea(params).then(response => {
                    this.moveAreas = response.map(x => x.areaInfo) || []
                })
            }
            if (this.isOperationBatteryChangeTask) {
                await funEmployees.GetEmployeeBatteryTaskAreas(params).then(response => {
                    this.batteryChangeAreas = response.map(x => x.areaInfo) || []
                })
            }
            if (this.isOperationMaintenanceLog) {
                await funEmployees.GetEmployeeMaintenanceTaskAreas(params).then(response => {
                    this.reparionAreas = response.map(x => x.areaInfo) || []
                })
            }
            this.showDialog = true
        },
        _close() {
            this.showDialog = false
        }
    }
}
</script>